import { render, staticRenderFns } from "./product-class-params.vue?vue&type=template&id=6b67c5ae&scoped=true"
import script from "./product-class-params.vue?vue&type=script&lang=ts"
export * from "./product-class-params.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b67c5ae",
  null
  
)

export default component.exports